import React from "react";
import './Card.css'

const Card = ({emoji, heading, detail}) => {
    return(

        <div className="Card">
            <img src={emoji} alt=""/>
            <span>{heading}</span>
            <span>{detail}</span>
            <button className="C-button">Learn More</button>

        </div>
    );
}

export default Card;
